import React, { Component } from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as productSearchActions from './productSearchActions';
import {MIN_PASSENGERS, MAX_PASSENGERS} from './productSearchPassengerConstants';
import moment from 'moment';
import classnames from 'classnames';
import {GlobalHeader, BackButton} from '../common/GlobalHeader';
import DesktopTimePicker from '../components/timePicker/Desktop';

class CharterTimeContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {error: null};
    this.goToDateSelection = this.goToDateSelection.bind(this);
    this.selectTravelTime = this.selectTravelTime.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
  }

  componentWillMount() {
    this.props.actions.resetTravelTime();
  }

  goToDateSelection() {
    this.props.actions.openDates();
  }

  selectTravelTime(time) {
    this.setState({error: null});
    this.props.actions.selectTravelTime(time);
  }

  onNextClick(e) {
    e.stopPropagation();

    if (!this.valid()) { return; }

    if (!this.props.selected_time) {
      this.setState({error: 'Please choose a time then tap Next'});
      return;
    }

    this.props.actions.broadcastSelectedCharterTime();
    this.props.actions.openOriginFilter();
  }

  getError() {
    return this.props.time_error || this.state.error;
  }

  valid() {
    return this.props.time_selection_validated && !this.props.time_error;
  }

  render() {
    return (
      <div className="charter-search-step">
        <GlobalHeader
          leftComponent={<BackButton onClick={this.goToDateSelection} />}
          title='Select a Departure Time'
        />
        <div className="product-search-form">
          <div className="form-params">
            <div
              className={classnames(
                'form-text-param',
                {empty: !this.props.selected_time}
              )}>
              <div>
                <label>Time</label>
                {this.renderTimeSelector()}
                {this.renderError()}
              </div>
            </div>
          </div>
          <br />
          <button
            className={classnames('btn btn-primary btn-block see-flights', {disabled: !this.valid()})}
            onClick={this.onNextClick}
          >
            Next
            <i className="blade-right-arrow"></i>
          </button>
        </div>
      </div>
    );
  }

  renderError() {
    const error = this.getError();
    if (!error) return;
    return ( 
      <span
        className="error-text"
        dangerouslySetInnerHTML={{__html: error}}
      ></span>
    );
  }

  renderTimeSelector() {
    if (this.onDesktop()) {
      return <DesktopTimePicker onChange={this.selectTravelTime} />;
    } else {
      return (
        <input
          type="time"
          className="form-control"
          onChange={(event) => { this.selectTravelTime(event.target.value); }}
        />
      );
    }
  }

  onDesktop() {
    return !!$('.layout-desktop').length;
  }
}

function mapStateToProps(state, ownProps) {
  return {
    selected_time: state.productSearch.travel_time_selection,
    time_selection_validated: state.productSearch.travel_time_selection_validated,
    time_error: state.productSearch.travel_time_error
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(productSearchActions, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CharterTimeContainer)